import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormWidgetBoatComponent } from '@modules/bcm/@work-flows/@form-widgets/boat/form-widget-boat.component';
import { GetBoatDialogModule } from '@shared/components/dialogs/get-boat-dialog/get-boat-dialog.module';
import { MatRadioModule } from '@angular/material/radio';
import { NumberInputModule } from '@shared/components/form/number-input/number-input.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HtmlLinksModule } from '@modules/bcm/@shared/components/html-links/html-links.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationModule } from '@core/translation/translation.module';
import { BoatEditorDialogComponent } from '@bcm-work-flows/@form-widgets/boat/boat-editor-dialog/boat-editor-dialog.component';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { BookingV2DimensionsComponent } from '@modules/bcm/booking-v2/components/dimensions/booking-v2-dimensions.component';

@NgModule({
    declarations: [FormWidgetBoatComponent, BoatEditorDialogComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatDatepickerModule,
        MatAutocompleteModule,

        GetBoatDialogModule,
        MatRadioModule,
        NumberInputModule,
        MatCheckboxModule,
        DirectivesModule,
        MatProgressSpinnerModule,
        HtmlLinksModule,
        MatTooltipModule,
        TranslationModule,
        CdkDrag,
        CdkDragHandle,
        BookingV2DimensionsComponent,
    ],
    exports: [FormWidgetBoatComponent]
})
export class FormWidgetBoatModule {

}
